<template>
  <div>
    <div class="About-title">
      <van-nav-bar title="关于我们" left-arrow @click-left="goBlack"></van-nav-bar>
    </div>
    <div class="About-content">
      <div class="About-c-title">智&nbsp;慧&nbsp;笔&nbsp;记</div>
      <div class="About-c-title2">远程在线课堂</div>
      <div class="About-c-title3">ver.1.1.0.05</div>
      <div class="About-c-ct">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;武汉高田计算机系统公司成立于1996年，
        长期从事教育装备技术的研发生产及教育行业系统工程建设，
        拥有一批博士，研究生学历员工，是集产，学，研一体化的高科技公司。
      </div>
      <div class="About-c-ct">
        公司与武汉大学，华中科技大学，中科院等科研院所建立长期深度战略合作，
        长期从事人工智能无边界交互系统的研究和开发工作，主要的产品有无边界交互黑板，无边界交互终端，无边界交互服务器，
        无边界交互平台系统等产品。公司广泛用于教育，政府机关企事业单位等各行各业。
      </div>
    </div>
  </div>
</template>

<script>
import { changPassword } from "@/api/login.js";
export default {
  data() {
    return {
      userId: JSON.parse(localStorage.getItem("user")).userId,
      oldpwd: "",
      newpwd: "",
      newpwd2: "",
      pwdType: "password",
    };
  },

  created() {},
  methods: {
    changepwd() {},
    goBlack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.About-title {
  height: 12vw;
  .van-nav-bar {
    background-color: rgb(37, 201, 145) !important;
  }
}
.About-content {
  margin-top: 12.13vw;
  padding: 0 9.259vw;
  .About-c-title {
    text-align: center;
    font-size: 8.889vw;
    color: #18d091;
    font-weight: 600;
    margin-bottom: 2.87vw;
  }
  .About-c-title2 {
    text-align: center;
    font-size: 4.44vw;
    color: #24292e;
    // font-weight: 600;
    margin-bottom: 5.185vw;
  }
  .About-c-title3 {
    text-align: center;
    font-size: 4.07vw;
    color: #24292e;
    // font-weight: 600;
    margin-bottom: 11.0195vw;
  }
  .About-c-ct {
    font-size: 4.07vw;
    color: #24292e;
    // font-weight: 600;
    margin-bottom: 4vw;
  }
}
</style>



